/**
 * @generated SignedSource<<773e24541b30fd1bf5837cf3c140d5c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DispatchConditionKind = "AccountDispatchCondition" | "AllUserDispatchCondition" | "OptInDispatchCondition" | "TreeFinishedDispatchCondition" | "TreeStartedDispatchCondition" | "TreeUnlockedDispatchCondition" | "UserDispatchCondition";
import { FragmentRefs } from "relay-runtime";
export type dispatchConditionsPreview_MessageDispatchFragment$data = {
  readonly excludes: ReadonlyArray<{
    readonly kind?: DispatchConditionKind;
    readonly rootNodeIds?: ReadonlyArray<string>;
    readonly userIds?: ReadonlyArray<string>;
    readonly " $fragmentSpreads": FragmentRefs<"removeDispatchConditionButton_DispatchConditionFragment">;
  }>;
  readonly id: string;
  readonly includes: ReadonlyArray<{
    readonly kind?: DispatchConditionKind;
    readonly rootNodeIds?: ReadonlyArray<string>;
    readonly userIds?: ReadonlyArray<string>;
    readonly " $fragmentSpreads": FragmentRefs<"removeDispatchConditionButton_DispatchConditionFragment">;
  }>;
  readonly " $fragmentType": "dispatchConditionsPreview_MessageDispatchFragment";
};
export type dispatchConditionsPreview_MessageDispatchFragment$key = {
  readonly " $data"?: dispatchConditionsPreview_MessageDispatchFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"dispatchConditionsPreview_MessageDispatchFragment">;
};

import dispatchConditionsPreview_Refetch_graphql from './dispatchConditionsPreview_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "removeDispatchConditionButton_DispatchConditionFragment"
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootNodeIds",
    "storageKey": null
  },
  (v0/*: any*/),
  (v1/*: any*/)
],
v4 = [
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "AccountDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "AllUserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
      },
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "type": "UserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeStartedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeFinishedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v3/*: any*/),
    "type": "TreeUnlockedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "OptInDispatchCondition",
    "abstractKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": dispatchConditionsPreview_Refetch_graphql,
      "identifierField": "id"
    }
  },
  "name": "dispatchConditionsPreview_MessageDispatchFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "includes",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "excludes",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MessageDispatch",
  "abstractKey": null
};
})();

(node as any).hash = "0be93c814fba0ccdd0c53fc5e5bcc445";

export default node;
